module.exports = __webpack_public_path__ + "static/media/06.6a599074.png";